import ListEdit from "../UI/ListEdit";
import {Link} from "react-router-dom";
import React, {Fragment, useState} from "react";
import Box from "../UI/Box";
import {convertToDisplayDate, getPaymentMethodLabel} from "../../utility/utility";
import {usePayout} from "../../hooks/usePayout";
import {usePayoutTransactions} from "../../hooks/usePayoutTransactions";

const PayoutTransactionList = (props) => {
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const {payout} = usePayout(props.payoutId);
    const {payoutTransactions, pagination} = usePayoutTransactions(props.payoutId, page, pageSize, 0);

    const payoutTransactionList = payoutTransactions.map(
        (payoutTransaction) => {
            return {
                type            : payoutTransaction.type,
                gross           : payoutTransaction.gross + ' ' + payoutTransaction.currency,
                fee             : payoutTransaction.fee + ' ' + payoutTransaction.currency,
                payout          : payoutTransaction.net + ' ' + payoutTransaction.currency,
                customer        : payoutTransaction.customerName,
                invoice         : payoutTransaction.invoiceNumber,
                paymentMethod   : getPaymentMethodLabel(payoutTransaction.paymentMethod),
                paymentReceived : convertToDisplayDate(payoutTransaction.created)
            }
        }
    );

    const handlePageChange = (pageNumber) => {
        setPage(pageNumber);
    };

    const handlePageSizeChange = (pageSize) => {
        setPageSize(pageSize);
        setPage(1);
    };

    const listHeaders = [
        'Type',
        'Gross',
        'Fee',
        'Payout',
        'Invoice',
        'Customer',
        'Payment method',
        'Payment received'
    ];

    const columns = {
        functionParams : [],
        dataKeys       : [
            'type',
            'gross',
            'fee',
            'payout',
            'invoice',
            'customer',
            'paymentMethod',
            'paymentReceived'
        ]
    }

    return (
        <Fragment>
            <Link to={'/payouts?provider=stripe'}>Back</Link>
            <Box>
                {payout && <h1>Payout: {payout.payoutId} {convertToDisplayDate(payout.availableOn)}</h1>}
                <ListEdit
                    headers={listHeaders}
                    items={payoutTransactionList}
                    columns={columns}
                    pagination={pagination}
                    handlePageChange={handlePageChange}
                    handlePageSizeChange={handlePageSizeChange}
                />
            </Box>
        </Fragment>

    );
};

export default PayoutTransactionList;